import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

async function getUserSubscription() {
    const response = await fetch('/api/get-account-subscription', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        const subscription = await response.json();
        return subscription;
    } else {
        return false;
    }
}

async function getUserData() {
    const response = await fetch('/api/get-account-data', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        const user_data = await response.json();
        return user_data;
    } else {
        return false;
    }
}

const logout = async (navigate) => {
    const response = await fetch("/api/logout", {
        method: "POST",
        credentials: "include"
    });

    if (response.ok) {
        navigate('/client-view/login');
    }
}

function ClientViewPageHeader({setSettingsVisibility}) {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);
    const [userSubscription, setUserSubscription] = useState("free")
    const [userName, setUserName] = useState("")
    const [version, setVersion] = useState("")

    const [versionHasSettings, setVersionHasSettings] = useState(false)

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    const handleOpenSettings = () => {
        setSettingsVisibility(true)
        console.log("Header ok")
    }

    useEffect(() => {
        async function fetchData() {
            setUserSubscription(await getUserSubscription());
            const userData = await getUserData()
            setUserName(userData.nome)
            setVersion(await window.pywebview.api.get_version())

            if (window.pywebview.api.bind_key && window.pywebview.api.get_bindend_key) {
                setVersionHasSettings(true)
            }
        }
        fetchData()
    }, []);

    const handleLogout = async () => {
        if (window.pywebview && window.pywebview.api && window.pywebview.api.clear_local_data) {
            try {
                await window.pywebview.api.clear_local_data();
                window.pywebview.api.toggle_udp_stream(false);
            } catch (err) {
            }
        }

        await logout(navigate);
    };

    return (
        <header className="flex items-center justify-between px-6 py-4 border-b border-slate-300 dark:border-[#233648] bg-white/50 dark:bg-[#16222d]/50 backdrop-blur-sm mt-[32px]">
            <div className="flex items-center gap-3">
                <div className="p-1.5 bg-primary rounded-lg text-white">
                    <span className="material-symbols-outlined text-xl">speed</span>
                </div>
                <div>
                    <h1 className="text-sm font-bold tracking-tight uppercase">LiveTelemetry</h1>
                    <p className="text-[10px] text-slate-500 font-medium tracking-widest">v{version} • SYNC CLIENT</p>
                </div>
            </div>
            <div className="flex items-center gap-3">
                {versionHasSettings &&
                    <button onClick={() => handleOpenSettings()} className={`cursor-pointer hover:text-white hover:bg-slate-500/10 hover:border-slate-400 flex items-center justify-center size-12 rounded-xl border border-slate-300 dark:border-[#324d67] text-slate-500 transition-all relative`}>
                        <span className="material-symbols-outlined text-2xl">settings</span>
                    </button>
                }

                <div className="relative group">
                    <div className="size-10 rounded-full bg-[#233648] border border-[#324d67] flex items-center justify-center cursor-pointer" onClick={toggleVisibility}>
                        <span className="material-symbols-outlined">person</span>
                    </div>
        
                    <div className={`absolute top-full right-0 mt-3 w-64 bg-[#111a22] border border-[#324d67] rounded-lg shadow-2xl dropdown-glow z-[60] overflow-hidden ${isVisible ? 'visible' : 'invisible'}`}>
                        <div className="p-4 bg-gradient-to-b from-[#1a2b3c] to-transparent border-b border-[#324d67]/50">
                            <div className="flex items-center gap-3">
                                <div className="size-10 rounded bg-primary/20 border border-primary/30 flex items-center justify-center">
                                    <span className="material-symbols-outlined text-primary">person</span>
                                </div>
                                <div className="flex flex-col">
                                    <span className="text-sm font-bold text-white tracking-tight uppercase">{userName}</span>
                                    <span className="text-[10px] font-bold text-acc-cyan uppercase tracking-widest">{userSubscription}</span>
                                </div>
                            </div>
                        </div>
                        <div className="p-1.5">        
                            <p onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 rounded text-acc-red hover:bg-acc-red/10 transition-colors group/item max-h-[40px] cursor-pointer">
                                <span className="material-symbols-outlined text-lg">logout</span>
                                <span className="text-xs font-bold uppercase tracking-wide">Logout</span>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}


export default ClientViewPageHeader;